import React from "react";
import { ImageAttributes } from "@/store";
import { Card } from "@/components/Card";
import { SvgSrcIcon } from "@/components/SvgSrcIcon";
import { cn } from "@/helpers/utils";

export interface NavCardProps extends React.HTMLAttributes<HTMLElement> {
  title: string;
  description?: string;
  href: string;
  image?: ImageAttributes;
  className?: string;
}

const NavCard = ({
  title,
  description,
  image,
  href,
  className,
  ...props
}: NavCardProps) => {
  return (
    <a href={href} {...props} className={cn("group", className)}>
      <Card
        className="h-full"
        cover={
          image && (
            <Card.Cover>
              <SvgSrcIcon
                src={image.src}
                height={image.height ?? 72}
                width={image.width ?? 72}
                className="svg-icon ml-4 mr-4 mt-4 transition duration-300 group-hover:scale-110"
              ></SvgSrcIcon>
            </Card.Cover>
          )
        }
        hoverable
      >
        <div className="text-center">
          <h5 className="subtitle mb-2 whitespace-pre-line font-semibold text-primary">
            {title}
          </h5>
          {description && (
            <p className="body text-sm group-hover:text-primary">
              {description}
            </p>
          )}
        </div>
      </Card>
    </a>
  );
};

export { NavCard };
